import { render, staticRenderFns } from "./SignViaEmail.vue?vue&type=template&id=5d0e21b0&scoped=true"
import script from "./SignViaEmail.vue?vue&type=script&lang=js"
export * from "./SignViaEmail.vue?vue&type=script&lang=js"
import style0 from "./SignViaEmail.vue?vue&type=style&index=0&id=5d0e21b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e21b0",
  null
  
)

export default component.exports